import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'column',
  columnId: null,
  column: null,
  columnStyle: null,
  columnChildren: null,
  columnComponent: null,
};

export const copyColumnSlice = createSlice({
  name: 'copyPasteColumn',
  initialState,
  reducers: {
    setCopyColumn: (state, action) => {
      //save paste value
      // let payload = action.payload;
      // let column = payload.column;
      // let newComponents = {};
      // const newChild = column.children.map((child) => {
      //   const comId = uuid();
      //   return comId;
      // });
      // column.children.map((child, index) => {
      //   let com = payload.component[child];
      //   let key = newChild[index];
      //   newComponents = {...newComponents,[key]: {...com,id : key}}
      // });
      // const colId = uuid();
      // let newColumn = {...column,id:colId,children:newChild};
      
      // state.columnId = newColumn.id;
      // state.column = JSON.stringify(newColumn);
      // state.columnStyle = JSON.stringify(newColumn.style);
      // state.columnChildren = newColumn.children;
      // state.columnComponent = JSON.stringify(newComponents);

      //save real value
      let payload = action.payload;
      let column = payload.column;
      let components = {};
      column.children.map((child) => {
        let com = payload.component[child];
        components = {...components,[com.id]: com}
      });
      
      state.columnId = column.id;
      state.column = JSON.stringify(column);
      state.columnStyle = JSON.stringify(column.style);
      state.columnChildren = column.children;
      state.columnComponent = JSON.stringify(components);
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCopyColumn } = copyColumnSlice.actions;

export default copyColumnSlice.reducer;
